@if (editMode) {
  <div>
    <label class="checkbox">
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        <input
          type="checkbox"
          [value]="'asLink'"
          [checked]="displayAsLink"
          (change)="setDisplayAsLink($event)"
          class="mr-3 checkbox-size" />
        <div class="checkbox-text">{{ 'COMMUNICATIONS.CONFIRMATION-AS-LINK' | translate }}</div>
      </div>
    </label>
  </div>
}

@if (!editMode) {
  <div>
    <div class="message-bubble">
      <div class="message-text">
        <div>{{ confirmationText }}</div>
        @if (displayAsLink) {
          <div>{{ 'COMMUNICATIONS.MESSAGE-REPLY' | translate }} : <a>https://topo.ai/confirmation</a></div>
        } @else {
          @for (confirmationButton of confirmationButtons; track confirmationButton.uId; let i = $index) {
            <div>{{ 'COMMUNICATIONS.MESSAGE-REPLY' | translate }} {{ i + 1 + ':' }} {{ confirmationButton.text }}</div>
          }
        }
      </div>
    </div>
  </div>
}
